import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface DiseaseReadFieldProps {
  label: string;
  value: ReactNode;
  multiline?: boolean;
}

export const DiseaseReadField = ({
  label,
  value,
  multiline = false,
}: DiseaseReadFieldProps) => {
  const isEmpty = value === "" || value === null || value === undefined;

  return (
    <div
      className={cn("flex gap-4", multiline ? "items-start" : "items-center")}
    >
      <span
        className={cn(
          "z-label mb-0 w-[170px] shrink-0 text-muted-foreground",
          multiline && "pt-2"
        )}
      >
        {label}
      </span>
      <div
        className={cn(
          "z-body min-w-0 flex-1 rounded-md border border-input bg-muted/30 px-3 text-foreground",
          multiline
            ? "min-h-9 whitespace-pre-wrap break-words py-2"
            : "flex h-9 items-center py-1"
        )}
      >
        {isEmpty ? <span className="text-muted-foreground">-</span> : value}
      </div>
    </div>
  );
};
